<template>
  <div
    class="position-absolute left-container"
    :style="{ height: height, top: top, width: '388px!important', overflow: `visible !important` }"
  >
    <el-row
      type="flex"
      align="middle"
      class="card-title text-hex-fff text-24px h-52px w-full bg-no-repeat flex items-center pt-10px px-10px"
    >
      <el-col :span="18" class="fz-14 m-b-5px">模型透明度设置</el-col>
      <el-col :span="1" :offset="5">
        <span class="iconfont icon-line-close" @click="closeComponents"></span>
      </el-col>
    </el-row>

    <modelCheckTree
      class="modelCheckTree"
      :player="player"
      :modelName="modelName"
      :currentNodeItemF="currentSelectedModelItem"
      :height="height"
      :multiple="false"
      :multiSelectedItems="multiSelectedItems"
      @setCheckedNode="getCheckedNode"
      @multiItems="multiSelected"
    ></modelCheckTree>
    <div class="setting position-absolute" id="Directives" v-drag>
      <el-card class="m-t-10px" :style="{ height: '180px' }">
        <el-row class="table-header">
          <el-col :span="18">
            <span class="text-color-white fz-14">模型透明度</span>
          </el-col>
          <el-col :span="1" :offset="5">
            <span class="iconfont icon-close text-color-white" @click="closeComponents"></span>
          </el-col>
        </el-row>
        <div>
          <el-slider
            v-model="transparencyValue"
            :min="0"
            :max="255"
            show-input
            @change="settingTransparency"
          ></el-slider>
          <div class="tr m-t-20px">
            <el-button size="mini" @click="resetTransparency">重 置</el-button>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import modelCheckTree from './modelCheckTree'

export default {
  name: 'transparencySetting',
  components: { modelCheckTree },
  props: {
    defaultCheckedKey: {
      type: Array,
      default: () => {
        return []
      },
    },
    height: {
      type: String,
      default: '35rem',
    },
    top: {
      type: String,
      default: '',
    },
    currentItem: {
      type: Number,
      default: 0,
    },
    modelParams: {
      type: Array,
      default: () => {
        return []
      },
    },
    player: {
      type: Object,
      default: () => {},
    },
    modelName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      transparencyValue: 255, // 设置透明度值
      sliderTimerOut: null, // 拖动防抖
      currentSelectedModelItem: 0, // 当前点击模型节点
      isMultiSelected: false,
      multiSelectedItems: [],
      selectModelItem: [], // 模型选择树选中节点
    }
  },
  created() {
    this.currentSelectedModelItem = this.currentItem
  },
  computed: {},
  watch: {
    currentItem(val) {
      if (val) {
        this.$nextTick(async () => {
          if (this.isMultiSelected) {
            this.multiSelectedItems = await this.player.Native.ModelTree.getMultiSelectedItems()
          }
          this.currentSelectedModelItem = val
        })
      }
    },
  },
  beforeDestroy() {
    if (!_.isEmpty(this.selectModelItem)) {
      this.player.Native.ModelTree.recoverItemAlpha(this.selectModelItem[0])
    }
  },
  methods: {
    closeComponents() {
      this.$emit('closeComponents', 'transparencySetting')
    },
    // 获取模型选中节点
    async getCheckedNode(data) {
      console.log(data)
      if (!_.isEmpty(this.selectModelItem)) {
        this.player.Native.ModelTree.recoverItemAlpha(this.selectModelItem[0])
      }
      this.selectModelItem = _.map(data, 'item')
      this.transparencyValue = await this.player.Native.ModelTree.getItemAlpha(data[0].item)
      if (this.isMultiSelected) {
        this.player.Native.ModelTree.setSelectItemNoEvent(0)
      }
    },
    // 选择模式切换
    async multiSelected(bool) {
      this.isMultiSelected = bool
      const toolName = bool ? 'system.ToolMultiSelect' : 'system.Pickup'
      this.player.Native.Tools.setCurrentTool(toolName)
      if (!_.isEmpty(this.selectModelItem)) {
        this.player.Native.ModelTree.recoverItemAlpha(this.selectModelItem[0])
        this.transparencyValue = 255
      }
    },
    // 设置模型透明度
    async settingTransparency() {
      if (this.sliderTimerOut) clearTimeout(this.sliderTimerOut)
      this.sliderTimerOut = setTimeout(async () => {
        this.player.Native.ModelTree.setSelectItemNoEvent(0)
        if (!_.isEmpty(this.selectModelItem) && this.selectModelItem[0]) {
          this.player.Native.ModelTree.setItemAlpha(this.selectModelItem[0], this.transparencyValue)
        }
        // const root = await window.player.Native.ModelTree.getRootItems()
        // const rootItems = _.map(root, 'item')
        // window.player.Native.ModelTree.setItemColor(rootItems, Number(`0xffffff${hex.join('')}`))
      }, 100)
    },
    // 重置模型透明度
    async resetTransparency() {
      this.player.Native.ModelTree.recoverItemAlpha(this.selectModelItem[0])
      this.transparencyValue = await this.player.Native.ModelTree.getItemAlpha(
        this.selectModelItem[0]
      )
    },
  },
}
</script>
<style lang="scss" scoped>

@import '../css/component.scss';
.modelCheckTree {
  height: calc(100% - 50px) !important;
  left: 0px !important;
  background-color: #ffffff00 !important;
}
.setting {
  left: 413px;
  top: 66px;
  width: 368px;
  background-color: #1b4555 !important;
  border-radius: 4px;
  z-index: 99;
  border: none;
  // transition: top 0.4s;
  /deep/.el-card {
    &__body {
      padding: 10px !important;
      height: 100% !important;
      background-color: #ffffff00 !important;
      border-radius: 2px;
    }
  }
}
/deep/ .el-slider__runway,
/deep/ .el-slider__bar {
  height: 16px !important;
}
/deep/ .el-slider__button-wrapper {
  top: -10px !important;
}
/deep/ .el-slider__bar {
  background: transparent !important;
}
/deep/ .el-slider__runway {
  margin-right: 145px !important;
  background: linear-gradient(to right, rgba(180, 180, 180, 0) 0%, rgb(180, 180, 180) 100%),
    url('/static/img/bc/transparency.png') !important;
}
/deep/ .el-slider__input {
  width: 120px !important;
  margin-top: 7px !important;
}
/deep/ .el-slider__button {
  height: 20px !important;
  border-radius: 40% !important;
}
/deep/ .el-input-group__append button.el-button {
  padding-left: 15px;
  padding-right: 15px;
  background: transparent !important;
  color: white !important;
  padding-top: 0px;
  padding-bottom: 0px;
  margin: 0px !important;
}
/deep/ .el-input-group__append {
  padding: 0;
}
/deep/ .el-checkbox {
  margin-bottom: 0 !important;
}
.position-absolute {
  position: absolute;
}
.fz-12 {
  font-size: 12px;
}
.fz-14 {
  font-size: 14px;
}
.m-t-10px {
  margin-top: 10px;
}
.m-t-20px {
  margin-top: 20px;
}
.m-t-5px {
  margin-top: 5px;
}
.text-color-white {
  color: white;
}

</style>
